class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    if (!facetForm.hasAttribute('data-manual-submit')) {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    FacetFiltersForm.applyGridPreference();
  }

  static applyGridPreference() {
    var saved = localStorage.getItem('grid-columns');
    if (!saved) return;

    var productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    productGrid.className = productGrid.className.replace(/\bgrid--\d-col-tablet-down\b/g, '').trim();
    productGrid.classList.add('grid--' + saved + '-col-tablet-down');

    document.querySelectorAll('.custom-mobile-grid-item').forEach(function (item) {
      item.classList.toggle('selected', item.dataset.columns === saved);
    });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // mobile filter modal events handled by document-level delegation in DOMContentLoaded
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.price-range-slider');
    if (!this.slider) {
      this.querySelectorAll('input').forEach((element) => {
        element.addEventListener('change', this.onRangeChange.bind(this));
      });
      return;
    }

    this.rangeMin = this.slider.querySelector('.price-range-slider__input--min');
    this.rangeMax = this.slider.querySelector('.price-range-slider__input--max');
    this.hasInteracted = false;
    this.trackActive = this.slider.querySelector('.price-range-slider__track-active');
    this.minDisplay = this.slider.querySelector('.price-range-slider__min-display');
    this.maxDisplay = this.slider.querySelector('.price-range-slider__max-display');
    this.hiddenInputs = this.querySelectorAll('input[type="hidden"]');
    this.maxValue = Number(this.slider.dataset.rangeMax);

    const currencyEl = this.slider.querySelector('.price-range-slider__limits span:last-child');
    this.currencySymbol = currencyEl ? currencyEl.textContent.replace(/[0-9.,]/g, '').trim() : '';

    this.decimalPlaces = 0;
    this.decimalSeparator = '.';
    const limitsEl = this.slider.querySelector('.price-range-slider__limits span:last-child');
    if (limitsEl) {
      const limitText = limitsEl.textContent.trim();
      const matches = limitText.match(/[.,]/g);
      if (matches) {
        const lastSeparator = matches[matches.length - 1];
        const lastIndex = limitText.lastIndexOf(lastSeparator);
        const decimals = limitText.substring(lastIndex + 1).replace(/[^0-9]/g, '');
        if (decimals.length === 1 || decimals.length === 2) {
          this.decimalPlaces = decimals.length;
          this.decimalSeparator = lastSeparator;
        }
      }
    }

    this.rangeMin.addEventListener('input', () => this.handleSliderInput('min'));
    this.rangeMax.addEventListener('input', () => this.handleSliderInput('max'));
    this.rangeMin.addEventListener('change', () => this.commitValues());
    this.rangeMax.addEventListener('change', () => this.commitValues());

    this.updateTrack();
  }

  formatDisplayPrice(value) {
    if (this.decimalPlaces > 0) {
      let formatted = value.toFixed(this.decimalPlaces);
      if (this.decimalSeparator && this.decimalSeparator !== '.') {
        formatted = formatted.replace('.', this.decimalSeparator);
      }
      return this.currencySymbol + formatted;
    }
    return this.currencySymbol + Math.round(value);
  }

  handleSliderInput(type) {
    if (!this.hasInteracted) this.hasInteracted = true;
    let minVal = Number(this.rangeMin.value);
    let maxVal = Number(this.rangeMax.value);

    if (type === 'min' && minVal > maxVal) {
      this.rangeMin.value = maxVal;
      minVal = maxVal;
    }
    if (type === 'max' && maxVal < minVal) {
      this.rangeMax.value = minVal;
      maxVal = minVal;
    }

    this.minDisplay.textContent = this.formatDisplayPrice(minVal);
    this.maxDisplay.textContent = this.formatDisplayPrice(maxVal);
    this.updateTrack();
  }

  updateTrack() {
    const minVal = Number(this.rangeMin.value);
    const maxVal = Number(this.rangeMax.value);
    const minPct = (minVal / this.maxValue) * 100;
    const maxPct = (maxVal / this.maxValue) * 100;
    this.trackActive.style.left = minPct + '%';
    this.trackActive.style.right = (100 - maxPct) + '%';
  }

  commitValues() {
    if (!this.hasInteracted) return;

    const minVal = Number(this.rangeMin.value);
    const maxVal = Number(this.rangeMax.value);

    if (this.hiddenInputs.length >= 2) {
      this.hiddenInputs[0].value = minVal === 0 ? '' : minVal;
      this.hiddenInputs[1].value = maxVal >= this.maxValue ? '' : maxVal;
    }

    this.hiddenInputs[0].dispatchEvent(new Event('input', { bubbles: true }));
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
  }

  adjustToValidValues(input) {
    const value = Number(input.value.replace(/[^0-9.]/g, ''));
    const min = Number((input.getAttribute('data-min') || '0').replace(/[^0-9.]/g, ''));
    const max = Number((input.getAttribute('data-max') || '0').replace(/[^0-9.]/g, ''));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


/* =========================
   SORT DROPDOWN (Desktop + Mobile)
========================= */

document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.desktop-sort-trigger, .custom-sort-trigger');
  if (trigger) {
    var dropdown = trigger.nextElementSibling;
    if (!dropdown) return;
    e.preventDefault();
    var isActive = dropdown.classList.contains('active');
    closeAllSortDropdowns();
    if (!isActive) {
      dropdown.classList.add('active');
      trigger.classList.add('active');
      trigger.setAttribute('aria-expanded', 'true');
    }
    return;
  }

  var item = e.target.closest('.desktop-sort-item, .custom-sort-item');
  if (item) {
    e.preventDefault();
    var value = item.getAttribute('data-value');
    var wrapper = item.closest('.desktop-sort-wrapper, .custom-mobile-sort');
    var dropdown = wrapper.querySelector('.desktop-sort-dropdown, .custom-sort-dropdown');
    var hiddenSelect = document.querySelector('#FacetSortForm select[name="sort_by"]');

    if (hiddenSelect && value) {
      hiddenSelect.value = value;
      hiddenSelect.dispatchEvent(new Event('input', { bubbles: true }));
    }

    dropdown.classList.remove('active');
    var trig = dropdown.previousElementSibling;
    if (trig) {
      trig.classList.remove('active');
      trig.setAttribute('aria-expanded', 'false');
    }
    return;
  }

  if (!e.target.closest('.desktop-sort-wrapper, .custom-mobile-sort')) {
    closeAllSortDropdowns();
  }
});

function closeAllSortDropdowns() {
  document.querySelectorAll('.desktop-sort-dropdown.active, .custom-sort-dropdown.active').forEach(function (dd) {
    dd.classList.remove('active');
  });
  document.querySelectorAll('.desktop-sort-trigger.active, .custom-sort-trigger.active').forEach(function (t) {
    t.classList.remove('active');
    t.setAttribute('aria-expanded', 'false');
  });
}

/* =========================
   CUSTOM MOBILE SORT/FILTER
========================= */

/*
 * BUG FIX: .custom-filter-trigger lives inside #ProductGridContainer.
 * renderProductGridContainer() replaces that container's innerHTML after
 * every filter/sort action, which destroys any listeners bound directly
 * to the old button element. Using document-level delegation ensures the
 * handler survives DOM replacement.
 */

/* FILTER OPEN / CLOSE - delegated click on document */
document.addEventListener('click', (e) => {
  const filterModal = document.querySelector('.mobile-filter-modal');
  if (!filterModal) return;

  // Open modal
  if (e.target.closest('.custom-filter-trigger, .mobile-facets__open')) {
    console.log('[Filter Debug] Filter trigger clicked - opening modal');
    e.preventDefault();
    filterModal.classList.add('active');
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden');
    document.body.style.overflow = 'hidden';
    return;
  }

  // Close modal via back button
  if (e.target.closest('.mobile-filter-modal__back')) {
    console.log('[Filter Debug] Back button clicked - closing modal');
    filterModal.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    document.body.style.overflow = '';
    return;
  }

  // Close modal via overlay
  if (e.target.closest('.mobile-filter-modal__overlay')) {
    console.log('[Filter Debug] Overlay clicked - closing modal');
    filterModal.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    document.body.style.overflow = '';
    return;
  }
});

/* CHIP TOGGLE - mobile filter pills */
document.addEventListener('change', (e) => {
  const chip = e.target.closest('.filter-chip input[type="checkbox"]');
  if (chip) {
    chip.closest('.filter-chip').classList.toggle('active', chip.checked);
  }
});

/* MOQ PILL TOGGLE */
document.addEventListener('click', (e) => {
  const moqPill = e.target.closest('.moq-pill');
  if (moqPill) {
    moqPill.classList.toggle('active');
  }
});

/* APPLY FILTERS - delegated */
document.addEventListener('click', (e) => {
  const applyBtn = e.target.closest('.mobile-filter-modal__apply');
  if (!applyBtn) return;
  console.log('[Filter Debug] Apply filters clicked');
  const modal = applyBtn.closest('.mobile-filter-modal');
  const form = modal.querySelector('form');
  if (form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, null);
  }
  modal.classList.remove('active');
  document.body.classList.remove('overflow-hidden');
  document.documentElement.classList.remove('overflow-hidden');
  document.body.style.overflow = '';
});

/* RESET FILTERS - delegated */
document.addEventListener('click', (e) => {
  const resetBtn = e.target.closest('.mobile-filter-modal__reset');
  if (!resetBtn) return;
  console.log('[Filter Debug] Reset filters clicked');
  document.body.classList.remove('overflow-hidden');
  document.documentElement.classList.remove('overflow-hidden');
  document.body.style.overflow = '';
  const url = window.location.pathname;
  window.location.href = url;
});



/* =========================
   GRID VIEW TOGGLE (Dropdown)
========================= */

function closeAllGridDropdowns() {
  document.querySelectorAll('.custom-mobile-grid-dropdown.active').forEach(function (dd) {
    dd.classList.remove('active');
  });
  document.querySelectorAll('.custom-mobile-grid-trigger.active').forEach(function (t) {
    t.classList.remove('active');
    t.setAttribute('aria-expanded', 'false');
  });
}

function applyGridColumns(cols) {
  var productGrid = document.getElementById('product-grid');
  if (!productGrid) return;

  productGrid.className = productGrid.className.replace(/\bgrid--\d-col-tablet-down\b/g, '').trim();
  productGrid.classList.add('grid--' + cols + '-col-tablet-down');

  document.querySelectorAll('.custom-mobile-grid-item').forEach(function (item) {
    item.classList.toggle('selected', item.dataset.columns === cols);
  });

  localStorage.setItem('grid-columns', cols);
}

// Toggle grid dropdown on trigger click
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.custom-mobile-grid-trigger');
  if (!trigger) return;
  e.preventDefault();
  e.stopPropagation();

  var dropdown = trigger.nextElementSibling;
  if (!dropdown) return;

  var isActive = dropdown.classList.contains('active');
  closeAllGridDropdowns();
  if (!isActive) {
    dropdown.classList.add('active');
    trigger.classList.add('active');
    trigger.setAttribute('aria-expanded', 'true');
  }
});

// Handle grid item selection
document.addEventListener('click', function (e) {
  var item = e.target.closest('.custom-mobile-grid-item');
  if (!item) return;
  e.preventDefault();

  var cols = item.dataset.columns;
  applyGridColumns(cols);

  // Close the dropdown
  var dropdown = item.closest('.custom-mobile-grid-dropdown');
  if (dropdown) {
    dropdown.classList.remove('active');
    var trig = dropdown.previousElementSibling;
    if (trig) {
      trig.classList.remove('active');
      trig.setAttribute('aria-expanded', 'false');
    }
  }
});

// Close grid dropdowns on outside click
document.addEventListener('click', function (e) {
  if (!e.target.closest('.custom-mobile-grid-toggle')) {
    closeAllGridDropdowns();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var saved = localStorage.getItem('grid-columns') || '2';

  var productGrid = document.getElementById('product-grid');
  if (productGrid) {
    productGrid.className = productGrid.className.replace(/\bgrid--\d-col-tablet-down\b/g, '').trim();
    productGrid.classList.add('grid--' + saved + '-col-tablet-down');
  }

  document.querySelectorAll('.custom-mobile-grid-item').forEach(function (item) {
    item.classList.toggle('selected', item.dataset.columns === saved);
  });
});
